<div class="div-arriere-plan-action" (click)="closeChangeVoters()"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">

    <div class="flex flex-column h-full content-between">
      <div>
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="closeChangeVoters()">
        <h3 class="bold light-blue text-center no-margin">TRANSFERT D’INVITATION</h3>
      </div>


      <p class="text-md dark-blue no-margin">Pour transférer une invitation suite à un problème d’adresse
        mail, veuillez remplir les champs suivants et cocher la case de transfert de responsabilité.</p>

      <div>
        <p class="text-md dark-blue no-margin bold">1. Adresse e-mail à changer</p>
        <div class="line-holder">
          <input type="email" id="old-email" class="mail-input" maxlength="250" (change)="validateVoter()"
            placeholder="{{ 'CHANGE-VOTER.MAIL-OLD' | translate }}" (keyup)="updateCounters()">
        </div>
        <div class="character-counter grey">{{oldMailCharacters}}/250</div>
        <p class="text-md dark-blue no-margin bold">2. Nouvelle adresse e-mail</p>
        <div class="line-holder">
          <input type="email" id="new-email" class="mail-input" maxlength="250"
            placeholder="{{ 'CHANGE-VOTER.MAIL-CONFIRM' | translate }}" (keyup)="updateCounters()">
        </div>
        <div class="character-counter grey">{{newMailCharacters}}/250</div>
        <p class="text-md dark-blue no-margin bold">3. Confirmer la nouvelle adresse e-mail</p>
        <div class="line-holder">
          <input type="email" id="new-email-2" [ngClass]="differentValuesEmails ? 'mail-input' : 'mail-input-red'"
            maxlength="250" placeholder="{{ 'CHANGE-VOTER.MAIL-CONFIRM' | translate }}" (keyup)="updateCounters()">
        </div>
        <div class="character-counter grey">{{confirmMailCharacters}}/250</div>
      </div>

      <div class="w-three-quarters flex margin-center gap-10 align-items-base">
        <input type="checkbox" id="confirmation-checkbox">
        <p class="text-md grey no-margin">En tant qu'organisateur de ce scrutin, j'assume l'entière
          responsabilité de
          transférer l'e-mail d'invitation
          Assesseur à cette adresse e-mail vérifiée.</p>
      </div>

      <div class="flex flex-column content-center align-items-center">
        <button [ngClass]="areFieldsValid() ? 'action-button' : 'disabled-action-button'"
          (click)="changeMail()">Confirmer le
          transfert</button>
        <p class="text-md dark-blue pointer" (click)="closeChangeVoters()">Annuler</p>
      </div>
    </div>

  </div>
</div>